<template>
  <b-container id="reports">
    <b-list-group>
      <b-list-group-item
        class="d-flex justify-content-between align-items-center"
      >
        Bericht mit allen Anfragen
        <b-button :disabled="isLoading" @click="sendReport" class="ml-5">
          <b-spinner small class="mr-1" v-if="isLoading" />
          {{ isLoading ? "Generating..." : "Generieren" }}
        </b-button>
      </b-list-group-item>
    </b-list-group>
    <b-alert
      class="mt-3"
      fade
      dismissible
      @dismissed="message = ''"
      :show="message.length > 0"
      :variant="success ? 'success' : 'danger'"
      >{{ message }}
    </b-alert>
  </b-container>
</template>

<script>
export default {
  name: "Reports",
  data() {
    return {
      success: false,
      message: "",
      isLoading: false
    };
  },
  methods: {
    sendReport() {
      this.isLoading = true;
      this.$http
        .get("/request/report")
        .then(() => this.updateAlert(true, "Der Bericht wurde erfolgreich an Ihre E-Mail gesendet"))
        .catch(() => this.updateAlert(false, "Fehler beim Versenden oder Generieren"));
    },
    updateAlert(success, message) {
      this.success = success;
      this.message = message;
      this.isLoading = false;
    }
  }
};
</script>

<style scoped></style>
